function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import SheetRenderVert from './shaders/sheet_render_vert.glsl';
import SheetRenderFrag from './shaders/sheet_render_frag.glsl';

// Used for pre-rendering the sheet into a different target, before placing it into the 3D scene.
var SheetRenderContext = /*#__PURE__*/function () {
  function SheetRenderContext(viewerImpl, renderContext, glRenderer, materialManager) {_classCallCheck(this, SheetRenderContext);
    this.viewerImpl = viewerImpl;
    this.renderContext = renderContext;
    this.glRenderer = glRenderer;

    this.materialManager = materialManager;
    this.materialName = '__material_2Don3D__';
    this.tmpVec = new THREE.Vector3();
  }_createClass(SheetRenderContext, [{ key: "createContext", value: function createContext()

    {
      this.sheetContext = new Autodesk.Viewing.Private.RenderContext();
      this.sheetContext.init(this.glRenderer, this.renderContext.settings.logicalWidth, this.renderContext.settings.logicalHeight, { offscreen: true });

      var config = this.renderContext.getConfig();
      // Disable unneeded things. Set background color to transparent.
      config.antialias = false;
      config.renderEdges = false;
      config.clearAlpha = 0;
      if (config.clearColor) {
        config.clearColor.set(1, 1, 1);
      } else {
        config.clearColorBottom.set(1, 1, 1);
        config.clearColorTop.set(1, 1, 1);
      }
      this.sheetContext.applyConfig(config);
    } }, { key: "setSize", value: function setSize()

    {var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.renderContext;
      if (!this.sheetContext) {
        return;
      }

      this.sheetContext.setSize(context.settings.logicalWidth, context.settings.logicalHeight);
      this.updateMaterial();
    }

    // Creates a scene for the plane geometry to sit on
  }, { key: "createScene", value: function createScene() {
      this.setSize();

      this.scene = new THREE.Scene();
      // Create unit size mesh. The size will be set by setting the scale
      this.planeGeometry = new THREE.PlaneBufferGeometry(1, 1);

      this.material = new THREE.ShaderMaterial({
        uniforms: {
          sheetMap: { type: 't', value: this.sheetContext.getColorTarget() },
          idMap: { type: 't', value: this.sheetContext.getIDTargets()[0] },
          modelIDv2: { type: 'v3', value: new THREE.Vector3() },
          resolution: { type: 'v2', value: new THREE.Vector2() },
          alphaTest: { type: 'f', value: 0 } },

        vertexShader: SheetRenderVert,
        fragmentShader: SheetRenderFrag,
        side: THREE.DoubleSide,
        transparent: true });

      this.material.supportsMrtNormals = true;

      this.updateMaterial();

      this.materialManager.addMaterialNonHDR(this.materialName, this.material);

      this.mesh = new THREE.Mesh(this.planeGeometry, this.material);
      this.mesh.matrixAutoUpdate = false;
      this.scene.add(this.mesh);
    } }, { key: "updateMaterial", value: function updateMaterial()

    {
      if (this.material) {
        var target = this.sheetContext.getColorTarget();
        // Update because in resize the targets will be recreated
        this.material.uniforms.sheetMap.value = target;
        this.material.uniforms.idMap.value = this.sheetContext.getIDTargets()[0];
        this.material.uniforms.resolution.value.set(1 / (target.width || 1), 1 / (target.height || 1));
      }
    } }, { key: "beginScene", value: function beginScene(

    scene, camera, lights) {
      if (!this.sheetContext) {
        this.createContext();
      }

      this.sheetContext.beginScene(scene, camera, lights, true);
    }

    // The sheet is rendered onto a separate buffer, without depth testing. This buffer is then used as a texture
    // which is projected onto a plane, that matches the pose and size of the original plane. This way, we can have
    // depth testing for the sheet so it blends correctly with the 3D model, while avoiding artifacts created by
    // rendering the sheet regularly with depth testing on
    // Optional context is e.g. for printing where the context is different
  }, { key: "renderScenePart", value: function renderScenePart(originalScene, wantColor, wantSAO, wantID) {var _model$loader, _model$loader$options;var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.renderContext;
      if (!originalScene.frags || !originalScene.frags.is2d) {
        return;
      }

      if (!this.scene) {
        this.createScene();
      }

      // For first pass, discard any pixels that have opacity <= 0.9, i.e. draw only opaque ones
      // For second (or if has only one pass), discard only pixels with opacity 0
      this.material.uniforms.alphaTest.value = !originalScene.needsTwoPasses || originalScene.isSecondPass ? 0 : 0.9;

      var modelId = originalScene.modelId;
      var model = this.viewerImpl.modelQueue().findModel(modelId);
      var bounds = model.getBoundingBox(true);
      var modelTransform = originalScene.frags.matrix;
      var placementTransform = (_model$loader = model.loader) === null || _model$loader === void 0 ? void 0 : (_model$loader$options = _model$loader.options) === null || _model$loader$options === void 0 ? void 0 : _model$loader$options.placementTransform;
      // Encode model id into vector
      this.material.uniforms.modelIDv2.value.set((modelId & 0xFF) / 255,
      (modelId >> 8 & 0xFF) / 255,
      (modelId >> 16 & 0xFF) / 255);

      // If AO has changed, the post pipeline needs to be reinit
      if (context.getAOEnabled() !== this.sheetContext.getAOEnabled()) {
        this.sheetContext.initPostPipeline(context.getAOEnabled(), false);
      }
      wantID = wantID && model.areAllVisible();
      // Render original scene to separate buffer
      // In case of rendering two passes, this stage will be the same for both, so we can skip it for
      // a performance improvement
      var skipIntermediateTarget = this.lastRenderedModel === model && originalScene.isSecondPass;
      if (!skipIntermediateTarget) {
        this.sheetContext.renderScenePart(originalScene, wantColor, wantSAO, wantID, false);
        this.sheetContext.presentBuffer();
      }


      // Update mesh with this scene's model's bounds
      // First set original bounds and location
      // Then apply transform
      var size = bounds.size();
      this.mesh.matrix.makeScale(size.x, size.y, 1.0);
      bounds.center(this.tmpVec);
      this.mesh.matrix.setPosition(this.tmpVec);
      if (placementTransform) {
        this.mesh.matrix.multiplyMatrices(placementTransform, this.mesh.matrix);
      }
      if (modelTransform) {
        this.mesh.matrix.multiplyMatrices(modelTransform, this.mesh.matrix);
      }
      this.mesh.matrixWorld.copy(this.mesh.matrix);
      // Now render mesh with projected texture
      this.scene.modelId = modelId;
      context.renderScenePart(this.scene, wantColor, wantSAO, wantID);

      this.lastRenderedModel = model;
    } }, { key: "destroy", value: function destroy()

    {
      if (this.material) {
        this.material.dispose();
        this.material = null;
      }

      if (this.planeGeometry) {
        this.planeGeometry.dispose();
        this.planeGeometry = null;
      }

      if (this.sheetContext) {
        this.sheetContext.cleanup();
        this.context = null;
      }

      this.renderContext = null;
      this.glRenderer = null;

    } }]);return SheetRenderContext;}();export { SheetRenderContext as default };